import { useState, useEffect, useRef } from 'react';
import outmazedLogo from '../../assets/footerLogo.svg';
import { getHeaderData } from './HeaderConfig';
import { Link } from 'react-router-dom';
import { PAGE_URL } from '../../config/appConfig';
import { BsTelephoneFill, BsEnvelopeFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [activeClass, setActiveClass] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const { SectionData } = useSelector((state) => state.siteInfo);

  const hendleToggle = () => {
    if (window.innerWidth < 768) {
      setIsNavOpen(!isNavOpen);
      document.body.classList.toggle('StopScroll', !isNavOpen);
    }
  };

  const handleButtonClick = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleDocumentClick = (event) => {
    if (menuRef.current && menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    if (menuOpen) {
      document.addEventListener('scroll', handleDocumentClick);
      document.addEventListener('click', handleDocumentClick);
    } else {
      document.removeEventListener('scroll', handleDocumentClick);
      document.removeEventListener('click', handleDocumentClick);
    }
    return () => {
      document.removeEventListener('scroll', handleDocumentClick);
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [menuOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setActiveClass(window.scrollY > 6 ? 'sticky' : '');
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className={`navtop ${activeClass}`}>
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg navbar-dark">
            {/* Mobile logo */}
            <Link className="navbar-brand d-lg-none" to={PAGE_URL.HOMEPAGE}>
              <img
                src={
                  (SectionData && SectionData?.SiteHeaderLogo?.url) ||
                  outmazedLogo
                }
                alt={SectionData ? SectionData?.SiteHeaderLogo.altTag : ''}
              />
            </Link>

            {/* Mobile toggle button */}
            <button
              className={`navbar-toggler ${menuOpen ? '' : 'collapsed'}`}
              type="button"
              onClick={() => {
                handleButtonClick();
                hendleToggle();
              }}
              aria-label="Toggle navigation"
            >
              <span className="icon-bar top-bar"></span>
              <span className="icon-bar middle-bar"></span>
              <span className="icon-bar bottom-bar"></span>
            </button>

            <div
              className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`}
              id="navbarNav"
              ref={menuRef}
            >
              <ul className="navbar-nav mx-auto">
                {getHeaderData().map((navItem, index) => {
                  if (navItem.children) {
                    // Dropdown
                    return (
                      <li className="nav-item dropdown" key={index}>
                        <a
                          href="#"
                          className="nav-link dropdown-toggle"
                          id={`navbarDropdown${index}`}
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={(e) => {
                            if (window.innerWidth < 992) {
                              // Mobile: prevent collapse and just open dropdown
                              e.preventDefault();
                              e.stopPropagation();
                              e.target.parentElement.classList.toggle('show');
                              e.target.nextElementSibling.classList.toggle('show');
                            }
                          }}
                        >
                          {navItem.label}
                        </a>
                        <ul
                          className="dropdown-menu" style={{ top: "60%" }}
                          aria-labelledby={`navbarDropdown${index}`}
                        >
                          {navItem.children.map((child, childIndex) => {
                            const isExternal =
                              child.href.startsWith("http") || child.href.startsWith("//");

                            return (
                              <li key={childIndex}>
                                {isExternal ? (
                                  <a
                                    className="dropdown-item"
                                    href={child.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                      handleButtonClick();
                                      hendleToggle();
                                    }}
                                  >
                                    {child.label}
                                  </a>
                                ) : (
                                  <Link
                                    className="dropdown-item"
                                    to={child.href}
                                    onClick={() => {
                                      handleButtonClick();
                                      hendleToggle();
                                    }}
                                  >
                                    {child.label}
                                  </Link>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    );
                  }

                  // Normal link
                  return (
                    <li className="nav-item" key={index}>
                      <Link
                        className={`nav-link ${navItem?.href === location.pathname ? 'NavactiveSer' : ''
                          }`}
                        aria-current="page"
                        to={navItem?.href}
                        onClick={() => {
                          handleButtonClick();
                          hendleToggle();
                        }}
                      >
                        {navItem?.label}
                      </Link>
                      {navItem?.image && (
                        <Link
                          className="navbar-brand d-none d-lg-block CenterLogo"
                          to={navItem?.href}
                        >
                          <img
                            src={
                              (SectionData && SectionData?.SiteHeaderLogo.url) ||
                              outmazedLogo
                            }
                            alt={
                              SectionData ? SectionData?.SiteHeaderLogo.altTag : ''
                            }
                          />
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>

              {/* Mobile contact section */}
              <div className="MobileInfo">
                <a
                  href={`tel://${SectionData?.SitePhoneNumber || ''}`}
                  onClick={() => {
                    handleButtonClick();
                    hendleToggle();
                  }}
                >
                  <BsTelephoneFill />
                  {SectionData?.SitePhoneNumber}
                </a>

                <a
                  href={`mailto:${SectionData?.SiteEmail || ''}`}
                  onClick={() => {
                    handleButtonClick();
                    hendleToggle();
                  }}
                >
                  <BsEnvelopeFill />
                  {SectionData?.SiteEmail}
                </a>
                <Link
                  to={PAGE_URL.GET_QUOTE}
                  className="MmenuGQbtn"
                  onClick={() => {
                    handleButtonClick();
                    hendleToggle();
                  }}
                >
                  GET QUOTE
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;

